import {VisionLinesStat} from './VisionLinesStat';
import {VisionValuesStat} from './VisionValuesStat';

export class VisionStat {
lines: VisionLinesStat[];
values: VisionValuesStat[];
}

